import React, { useEffect } from 'react';
import TypeMate from 'typemate';
import cn from 'classnames';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import { AnchorArrow } from 'react-scale/components';

const SectionTitle = ({
  overtitle,
  title,
  product,
  subtitle,
  marginBottom,
  link,
  centered,
  themeColors,
  theme
}) => {
  const whoSelectot = title || subtitle
  const idSelector = whoSelectot.toLowerCase().replace(',', ' ').replace(/[^a-zA-Z ]/g, "").split(' ')[0];

  useEffect(() => {
    const articleElement = document.querySelector(`.section-${idSelector}`);
    const typeMateInstance = new TypeMate(articleElement, { selector: 'h1, p' });

    // Run it
    typeMateInstance.apply();
  }, []);

  return (
    <div
      className={cn(`section-${idSelector}`, 'md:max-w-4xl', {
        'text-center': centered,
        'mb-24': marginBottom
      })}
    >
      {overtitle && (
        <h2
          style={{ color: themeColors?.overtitleColor }}
          className={cn(
            'inline-block text-overtitle mb-6',
            !themeColors?.overtitleColor && 'text-gradient'
          )}
        >
          {overtitle}
        </h2>
      )}
      <h1
        className={cn(
          titleTheme[theme],
          'font-aeonik mb-6 text-white w-full',
          'text-4xl lg:text-5xl'
        )}
      >
        {title} <span className="text-gradient">{product}</span>
      </h1>
      {subtitle && (
        <p className={cn(textTheme[theme], 'text-lg text-white')}>
          <ReactMarkdown rehypePlugins={[rehypeRaw]}>{subtitle}</ReactMarkdown>
        </p>
      )}
      {link && (
        <div className="mt-8 text-lg">
          <AnchorArrow
            href={link.href}
            text={link.text}
            theme="light"
            textColor={linkTheme[theme]}
          />
        </div>
      )}
    </div>
  );
};

const titleTheme = {
  dark: 'text-white',
  light: 'text-black'
};

const textTheme = {
  dark: 'text-white',
  light: 'text-gray-800'
};

const linkTheme = {
  dark: 'text-scale-skyblue',
  light: 'text-malibu'
};

SectionTitle.defaultProps = {
  theme: 'dark',
  centered: false,
  overtitle: '',
  title: 'Title',
  marginBottom: true,
  themeColors: undefined
};

export default SectionTitle;
